module.exports = __webpack_public_path__ + "img/share-facebook.e1a6e46b.svg";